import { axiosGet, axiosPost } from "../../../../../react_axios/Axios"
import { GET_HOTEL_ENQUIRY_DETAILS, INSERT_HOTEL_ENQUIRY_ACCOMMODATION_LOG, getHotelEnquiryDetailsUrl, insertExhHotelAccommodationLogUrl, getHotelDetailsUrl,GET_HOTEL_DETAILS } from "../../../../../utils/constants"

export const getHotelEnquiryDetails_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }
        // console.log("getMeetingRoomDetails_action ----->", params)
        const res = await axiosGet(getHotelEnquiryDetailsUrl, params)

        dispatch({
            type: GET_HOTEL_ENQUIRY_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getHotelDetails_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhRegistrationID: sessionStorage.getItem('ExhRegistrationIDSS'),
            ExhVisitorID: JSON.parse(sessionStorage.getItem('VisitorDataSS')) != null ? JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID : null,
        }
        // console.log("getMeetingRoomDetails_action ----->", params)
        const res = await axiosGet(getHotelDetailsUrl, params)

        dispatch({
            type: GET_HOTEL_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertExhHotelAccommodationLog_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhRegistrationID: sessionStorage.getItem('ExhRegistrationIDSS'),
            ExhVisitorID: JSON.parse(sessionStorage.getItem('VisitorDataSS')) != null ? JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID : null,
        }
        // console.log("getMeetingRoomDetails_action ----->", params)
        const res = await axiosPost(insertExhHotelAccommodationLogUrl, params)

        dispatch({
            type: INSERT_HOTEL_ENQUIRY_ACCOMMODATION_LOG,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}